import { THEMES_ACTION as ACTION_TYPE } from '../types/actionTypes';
const setInitialThemes = dispatch => themes => dispatch({
  type: ACTION_TYPE.SET_INITIAL_THEMES,
  payload: {
    initialThemes: themes
  }
});
const setThemes = dispatch => themes => dispatch({
  type: ACTION_TYPE.SET_THEMES,
  payload: {
    themes
  }
});
const setKeywords = dispatch => keywords => dispatch({
  type: ACTION_TYPE.SET_KEYWORDS,
  payload: {
    keywords
  }
});
const setKeywordsLoading = dispatch => loading => dispatch({
  type: ACTION_TYPE.SET_KEYWORDS_LOADING,
  payload: {
    keywordsLoading: loading
  }
});
const setKeywordsError = dispatch => error => dispatch({
  type: ACTION_TYPE.SET_KEYWORDS_ERROR,
  payload: {
    keywordsError: error
  }
});
const setThemesLoading = dispatch => loading => dispatch({
  type: ACTION_TYPE.SET_THEMES_LOADING,
  payload: {
    themesLoading: loading
  }
});
const setThemesError = dispatch => error => dispatch({
  type: ACTION_TYPE.SET_THEMES_ERROR,
  payload: {
    themesError: error
  }
});
const addTheme = dispatch => theme => dispatch({
  type: ACTION_TYPE.ADD_THEME,
  payload: {
    theme
  }
});
const setThemesChanged = dispatch => val => dispatch({
  type: ACTION_TYPE.SET_THEMES_CHANGED,
  payload: {
    themesChanged: val
  }
});
const setThemesAdded = dispatch => val => dispatch({
  type: ACTION_TYPE.SET_THEMES_ADDED,
  payload: {
    themesAdded: val
  }
});
const setThemesDeleted = dispatch => val => dispatch({
  type: ACTION_TYPE.SET_THEMES_DELETED,
  payload: {
    themesDeleted: val
  }
});
// sometimes we need to update multiple state values at once
const setMultiple = dispatch => payload => dispatch({
  type: ACTION_TYPE.SET_MULTIPLE,
  payload
});
export default {
  setInitialThemes,
  setThemes,
  setKeywords,
  setKeywordsLoading,
  setKeywordsError,
  setThemesLoading,
  setThemesError,
  addTheme,
  setThemesChanged,
  setThemesAdded,
  setThemesDeleted,
  setMultiple
};